module.exports = __webpack_public_path__ + "img/image78.508a18e4.png";